import classnames from 'classnames'
import { observer } from 'mobx-react-lite'
import { Button } from 'shared/ui'
import styles from './styles.module.scss'

export type IToggleChipGroupProps<T extends string | number> = {
  items: T[]
  columns: number
  isActive: (item: T) => boolean
  getLabel: (item: T) => string
  onToggle: (item: T) => void
}

export const ToggleChipGroup = observer(
  <T extends string | number>({
    items,
    columns,
    isActive,
    getLabel,
    onToggle,
  }: IToggleChipGroupProps<T>) => (
    <div className={styles.wrap} style={{ gridTemplateColumns: `repeat(${columns}, 1fr)` }}>
      {items.map((item) => (
        <Button
          key={item}
          typeBtn={'text'}
          className={classnames(styles.chip, { [styles.active]: isActive(item) })}
          text={getLabel(item)}
          onClick={() => onToggle(item)}
        />
      ))}
    </div>
  )
)
